import React from "react";

function UpDown({ upHandler, downHandler }) {
  return (
    <div
      className="btn-group-vertical "
      role="group"
      aria-label="Up Down Buttons"
      style={{
        height: "38px",
      }}
    >
      <button
        type="button"
        className="btn "
        style={{
          overflow: "hidden",
          padding: "0px 5px",
        }}
        onClick={(e) => {
          upHandler && typeof upHandler === "function" && upHandler();
        }}
      >
        <span> &#9652;</span>
      </button>
      <button
        type="button"
        className="btn"
        style={{
          overflow: "hidden",
          padding: "0px 5px",
        }}
        onClick={(e) => {
          downHandler && typeof downHandler === "function" && downHandler();
        }}
      >
        <span
          style={{
            transform: "rotate(180deg)",
            display: "block",
          }}
        >
          &#9652;
        </span>
      </button>
    </div>
  );
}

export default UpDown;
